import { END_POINT_SEVER } from "../constants";
import axios from "axios";

export const login = async (data) => {
  try {
    const url = `${END_POINT_SEVER}/api/auth/login`;
    const _res = await axios.post(url, data);
    return _res.data;
  } catch (error) {
    console.error("error",error);
    console.error("message",error?.response?.data?.message);
    return { error: true,message:error?.response?.data?.message };
  }
};

export const logout = async () => {
  try {
    await localStorage.removeItem();
    await localStorage.clear();
  } catch (error) {
    console.log("logout error: ", error);
  }
};
